<template>
  <el-dialog
    title="告警通知"
    :visible.sync="dialogVisible"
    width="1000px"
    :before-close="handleClose"
    :close-on-click-modal="false"
    append-to-body
  >
    <el-tabs v-model="activeTab" @tab-click="tabChange">
      <el-tab-pane label="告警配置" name="alert">
        <div class="alert-toolbar">
          <el-button type="primary" size="mini" @click="openAdd">新 增</el-button>
          <span class="alert-tip">故障发生时发送告警邮件，故障消除时发送恢复通知；同一配置24小时内最多发送“24小时上限”封告警邮件，超出后不再发送。</span>
        </div>
        <DiluTable
          :list="alertData"
          :tableConfig="tableConfig"
          :total="total"
          :pageSize="searchParams.pageSize"
          :loading="loading"
          height="330"
          @currentChange="currentChange"
        >
          <el-table-column prop="fault" label="告警项目" align="left" min-width="130" show-overflow-tooltip />
          <el-table-column prop="faultChinese" label="参数显示" align="left" min-width="110" show-overflow-tooltip />
          <el-table-column label="故障等级" align="center" width="90">
            <template slot-scope="scope">{{ levelText(scope.row.faultLevel) }}</template>
          </el-table-column>
          <el-table-column label="设备网关" align="center" width="140" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.gateway || '全部' }}</template>
          </el-table-column>
          <el-table-column label="从机地址" align="center" width="90">
            <template slot-scope="scope">{{ scope.row.gateway ? (scope.row.address || '全部') : '全部' }}</template>
          </el-table-column>
          <el-table-column prop="mail" label="收件邮箱" align="left" min-width="180" show-overflow-tooltip />
          <el-table-column prop="counts" label="24小时上限" align="center" width="100" />
          <el-table-column label="状态" align="center" width="80">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                :active-value="10"
                :inactive-value="20"
                @change="statusChange(scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="110">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="openEdit(scope.row)">编辑</el-button>
              <el-button type="text" size="mini" class="danger-text" @click="deleteAlert(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </DiluTable>
      </el-tab-pane>

      <el-tab-pane label="发送记录" name="mail">
        <DiluTable
          :list="mailData"
          :tableConfig="tableConfig"
          :total="mailTotal"
          :pageSize="mailSearchParams.pageSize"
          :loading="mailLoading"
          height="330"
          @currentChange="mailCurrentChange"
        >
          <el-table-column prop="subject" label="邮件标题" align="left" min-width="200" show-overflow-tooltip />
          <el-table-column prop="mailto" label="收件人" align="left" min-width="160" show-overflow-tooltip />
          <el-table-column prop="fault" label="告警项目" align="left" min-width="110" show-overflow-tooltip />
          <el-table-column prop="gateway" label="设备网关" align="center" width="140" show-overflow-tooltip />
          <el-table-column label="状态" align="center" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 10" class="success-text">成功</span>
              <span v-else class="danger-text">失败</span>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" label="发送时间" align="center" width="160" />
          <el-table-column prop="remark" label="备注" align="left" min-width="140" show-overflow-tooltip />
        </DiluTable>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      :title="isEdit ? '编辑告警配置' : '新增告警配置'"
      :visible.sync="formVisible"
      width="620px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="120px" size="mini">
        <el-form-item label="项目">
          <el-input v-model="ruleForm.project" disabled />
        </el-form-item>
        <el-form-item label="设备">
          <el-select
            v-model="ruleForm.device"
            placeholder="全部设备"
            style="width:100%;"
            filterable
            clearable
            :disabled="isEdit"
            @change="deviceChange"
          >
            <el-option label="全部设备" value="" />
            <el-option
              v-for="(item, index) in deviceList"
              :key="index"
              :label="deviceLabel(item)"
              :value="item.gateway + '|' + item.address"
            />
          </el-select>
          <span class="form-tip">不选择设备表示项目下所有设备的该故障都发送告警</span>
        </el-form-item>
        <el-form-item label="告警项目" prop="faults">
          <el-select
            v-model="ruleForm.faults"
            filterable
            placeholder="请选择故障项目"
            style="width:100%;"
          >
            <el-option
              v-for="(item, index) in faultItems"
              :key="index"
              :label="item.chinese ? item.chinese + '（' + item.name + '）' : item.name"
              :value="item.name"
              :disabled="!isEdit && item.configured > 0"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="触发值">
          <el-input v-model="ruleForm.triggerValue" placeholder="留空表示任意非0故障码" style="width:200px;" />
        </el-form-item>
        <el-form-item label="复位值">
          <el-input v-model="ruleForm.resetValue" placeholder="留空表示非触发值以外都是复位值" style="width:200px;" />
        </el-form-item>
        <el-form-item label="收件人邮箱" prop="mail">
          <el-input v-model="ruleForm.mail" placeholder="多个邮箱请用逗号分隔" />
        </el-form-item>
        <el-form-item label="24小时上限" prop="counts">
          <el-input-number v-model="ruleForm.counts" :min="1" :max="999" style="width:160px;" />
          <span class="form-tip">24小时内最多发送的告警邮件数量，超出后不再发送</span>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="ruleForm.status" :active-value="10" :inactive-value="20" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="ruleForm.remark" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="testMail">发送测试邮件</el-button>
        <el-button size="mini" @click="formVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import DiluTable from "@/components/public/dilu-table.vue";
export default {
  data() {
    return {
      dialogVisible: false,
      activeTab: "alert",
      loading: false,
      mailLoading: false,
      alertData: [],
      total: 0,
      searchParams: {
        pageNum: 1,
        pageSize: 10,
        project: null,
      },
      mailData: [],
      mailTotal: 0,
      mailSearchParams: {
        pageNum: 1,
        pageSize: 10,
        project: null,
      },
      tableConfig: {
        isTree: false,
        isPage: true,
      },
      deviceList: [],
      faultItems: [],
      formVisible: false,
      isEdit: false,
      currentId: null,
      ruleForm: this.initForm(),
      rules: {
        faults: [{ required: true, message: "请选择告警项目", trigger: "change" }],
        mail: [
          { required: true, message: "请填写收件人邮箱", trigger: "blur" },
          { validator: this.checkMail, trigger: "blur" },
        ],
        counts: [{ required: true, message: "请设置24小时最多发送次数", trigger: "blur" }],
      },
    };
  },
  props: ["alertVisible", "project"],
  components: {
    DiluTable,
  },
  watch: {
    alertVisible(newValue) {
      this.dialogVisible = newValue;
      if (newValue) {
        this.searchParams.project = this.project;
        this.mailSearchParams.project = this.project;
        this.searchParams.pageNum = 1;
        this.mailSearchParams.pageNum = 1;
        this.loadAlertList();
        this.loadDeviceList();
        if (this.activeTab == "mail") {
          this.loadMailList();
        }
      }
    },
    project(newValue) {
      this.searchParams.project = newValue;
      this.mailSearchParams.project = newValue;
    },
  },
  methods: {
    initForm() {
      return {
        project: null,
        device: "",
        faults: null,
        mail: "",
        counts: 5,
        triggerValue: "",
        resetValue: "",
        status: 10,
        remark: "",
      };
    },
    checkMail(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }
      let reg = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)+$/;
      let list = value.split(/[,;，；]/);
      for (let i = 0; i < list.length; i++) {
        let mail = list[i].trim();
        if (!mail || !reg.test(mail)) {
          callback(new Error("邮箱格式不正确：" + mail));
          return;
        }
      }
      callback();
    },
    deviceLabel(item) {
      let label = item.gateway + " - " + item.address;
      if (item.categoryName) {
        label += "（" + item.categoryName + (item.modelName ? " " + item.modelName : "") + "）";
      }
      return label;
    },
    levelText(level) {
      if (level == 10) {
        return "轻微";
      } else if (level == 20) {
        return "一般";
      } else if (level == 30) {
        return "严重";
      }
      return "";
    },
    tabChange(tab) {
      if (tab.name == "mail") {
        this.loadMailList();
      }
    },
    //告警配置列表
    loadAlertList() {
      this.loading = true;
      this.request.faultAlertList(this.searchParams).then((res) => {
        this.loading = false;
        if (res.code == 0) {
          this.alertData = res.data;
          this.total = res.dataMaxCount;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    //发送记录
    loadMailList() {
      this.mailLoading = true;
      this.request.faultAlertMails(this.mailSearchParams).then((res) => {
        this.mailLoading = false;
        if (res.code == 0) {
          this.mailData = res.data;
          this.mailTotal = res.dataMaxCount;
        }
      }).catch(() => {
        this.mailLoading = false;
      });
    },
    currentChange(e) {
      this.searchParams.pageNum = e;
      this.loadAlertList();
    },
    mailCurrentChange(e) {
      this.mailSearchParams.pageNum = e;
      this.loadMailList();
    },
    //项目下设备
    loadDeviceList() {
      if (!this.project) {
        return;
      }
      this.request.deviceList({ project: this.project }).then((res) => {
        if (res.code == 0) {
          this.deviceList = res.data || [];
        }
      });
    },
    //已选择的告警项目（单选，统一转为数组处理）
    selectedFaults() {
      let value = this.ruleForm.faults;
      if (!value) {
        return [];
      }
      return Array.isArray(value) ? value : [value];
    },
    //解析选择设备（gateway|address）
    parseDevice() {
      let device = this.ruleForm.device;
      if (!device) {
        return { gateway: null, address: null };
      }
      let array = ("" + device).split("|");
      return {
        gateway: array[0] ? array[0] : null,
        address: array[1] ? array[1] : null,
      };
    },
    //项目下可配置的故障项目
    loadFaultItems() {
      let device = this.parseDevice();
      this.request.faultAlertItems({
        project: this.project,
        gateway: device.gateway,
        address: device.address,
      }).then((res) => {
        if (res.code == 0) {
          this.faultItems = res.data || [];
          if (!this.isEdit) {
            this.ruleForm.faults = null;
          }
        }
      });
    },
    deviceChange() {
      this.loadFaultItems();
    },
    openAdd() {
      this.isEdit = false;
      this.currentId = null;
      this.ruleForm = this.initForm();
      this.ruleForm.project = this.project;
      this.loadFaultItems();
      this.formVisible = true;
    },
    openEdit(row) {
      this.isEdit = true;
      this.currentId = row.id;
      this.ruleForm = {
        project: row.project,
        device: row.gateway ? row.gateway + "|" + (row.address ? row.address : "") : "",
        faults: row.fault ? row.fault : null,
        mail: row.mail,
        counts: row.counts,
        triggerValue: row.triggerValue,
        resetValue: row.resetValue,
        status: row.status,
        remark: row.remark,
      };
      this.loadFaultItems();
      this.formVisible = true;
    },
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (!valid) {
          return;
        }
        let device = this.parseDevice();
        let params = {
          project: this.project,
          gateway: device.gateway,
          address: device.address,
          mail: this.ruleForm.mail,
          counts: this.ruleForm.counts,
          triggerValue: this.ruleForm.triggerValue,
          resetValue: this.ruleForm.resetValue,
          status: this.ruleForm.status,
          remark: this.ruleForm.remark,
        };
        if (this.isEdit) {
          params.id = this.currentId;
          let faults = this.selectedFaults();
          params.fault = faults.length > 0 ? faults[0] : null;
          this.request.faultAlertEdit(params).then((res) => {
            if (res.code == 0) {
              this.$message.success("修改成功");
              this.formVisible = false;
              this.loadAlertList();
            }
          });
        } else {
          params.faults = this.selectedFaults();
          this.request.faultAlertAdd(params).then((res) => {
            if (res.code == 0) {
              let skip = res.data && res.data.skip ? res.data.skip : [];
              if (skip.length > 0) {
                this.$message.warning("部分告警项目已配置，已跳过：" + skip.join("、"));
              } else {
                this.$message.success("新增成功");
              }
              this.formVisible = false;
              this.loadAlertList();
            }
          });
        }
      });
    },
    //发送测试邮件
    testMail() {
      if (!this.ruleForm.mail) {
        this.$message.error("请先填写收件人邮箱");
        return;
      }
      let faults = this.selectedFaults();
      this.request.faultAlertTestMail({
        mail: this.ruleForm.mail,
        fault: faults.length > 0 ? faults.join("、") : null,
        counts: this.ruleForm.counts,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg ? res.msg : "测试邮件已发送，请查收");
        }
      });
    },
    //启用/禁用
    statusChange(row) {
      this.request.faultAlertStatus({ id: row.id, status: row.status }).then((res) => {
        if (res.code == 0) {
          this.$message.success(row.status == 10 ? "已启用" : "已禁用");
        } else {
          this.loadAlertList();
        }
      });
    },
    deleteAlert(row) {
      this.$confirm("确认删除告警项目【" + row.fault + "】的告警通知配置？", "提示", {
        type: "warning",
      }).then(() => {
        this.request.faultAlertDelete({ id: row.id }).then((res) => {
          if (res.code == 0) {
            this.$message.success("删除成功");
            this.loadAlertList();
          }
        });
      }).catch(() => {});
    },
    handleClose() {
      this.formVisible = false;
      this.dialogVisible = false;
      this.$emit("handleClose");
    },
  },
};
</script>

<style lang="scss" scoped>
.alert-toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  .alert-tip {
    margin-left: 12px;
    font-size: 12px;
    color: #909399;
  }
}

.form-tip {
  margin-left: 10px;
  font-size: 12px;
  color: #909399;
}

.danger-text {
  color: #f56c6c;
}

.success-text {
  color: #67c23a;
}
</style>
